export default "__VITE_ASSET__2Dxcgbom__"